export const formatScore = num => {
    if (num !== undefined && num !== null) {
        if (num > 100) {
            return 99;
        }
        return Math.ceil(num);
    } else {
        return 0;
    }
};
